<template>
  <div
    class="wireless-box-view"
    v-loading="loading.value"
    :element-loading-text="loading.text"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template v-if="!empty">
      <status-bar v-bind="status"></status-bar>
      <sensorList :list="seneorList" />
    </template>

    <template v-else>
      <div class="hint">{{ $t('暂无数据') }}</div>
    </template>
  </div>
</template>

<script>
let pmNameObj = {
  pm1: 'PM1.0 浓度',
  pm25: ' PM2.5',
  pm10: 'PM10',
  pmLevel: 'pm等级',
  pm1Atm: 'PM1.0 浓度',
  pm25Atm: ' PM2.5 浓度',
  pm10Atm: 'PM10 浓度',
  parCount1: '0.3以上颗粒数',
  parCount2: '0.5以上颗粒数',
  parCount3: '1.0以上颗粒数',
  parCount4: '2.5以上颗粒数',
  parCount5: '5.0以上颗粒数',
  parCount6: '10以上颗粒数',
  pmFault: '颗粒传感器故障'
};

import { getSensorsGradeServer } from '@/api/devices';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

import StatusBar from './components/status-bar.vue';
import sensorList from './components/sensor-list.vue';
import { isEmpty } from '@/utils/is';

export default {
  name: 'CT1226',
  mixins: [singleDeviceMixin],
  components: {
    sensorList,
    StatusBar
  },
  sockets: {
    '/socket/detail'(res) {
      this.setData(res);
    }
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      seneorList: [], // 实时数据
      status: {
        alarmStatus: 0,
        runState: 0
      },
      empty: false
    };
  },
  methods: {
    initData() {
      this.RG04Obj = {};
      this.RG04Data = [];
      this.GM606Data = [];
      this.PMS6003Data = [];
      this.NRHM01Obj = {};
      this.NRHM01Data = [];

      this.realData = [];
    },

    setData(res) {
      //   console.log('res: ', res);

      this.status.alarmStatus = res.state;
      this.status.runState = res.runstate;

      let sensorArr = [];
      try {
        let { gm606Mod_0, gm606Mod_1, gm606Mod_2, gm606Mod_3, nrhM01Mod, smokeMod } = res.mods;

        if (!isEmpty(gm606Mod_0)) {
          sensorArr.push(gm606Mod_0);
        }

        if (!isEmpty(gm606Mod_1)) {
          sensorArr.push(gm606Mod_1);
        }

        if (!isEmpty(gm606Mod_2)) {
          sensorArr.push(gm606Mod_2);
        }
        if (!isEmpty(gm606Mod_3)) {
          sensorArr.push(gm606Mod_3);
        }
        if (!isEmpty(sensorArr)) {
          this.GM606Data = [];

          sensorArr.forEach(item => {
            this.upGM606DataHandler(res.sn, item);
          });
        }
        if (!isEmpty(smokeMod)) {
          this.upPMS6003ModHandler(smokeMod);
        }

        if (!isEmpty(nrhM01Mod)) {
          this.upNRHM01ModHandler(res.sn, nrhM01Mod);
        }

        this.packageSensorViewDataHandler();

        //   case 'RG04':
        //     this.upRG04ModHandler(sn, mods.nuclearMod, beginTime, deviceType);
        //     break;
      } catch (err) {
        this.empty = true;
        console.error('[WIRELESSBOX][MONITRO][update error]', err);
      }
    },
    upGM606DataHandler(sn, val) {
      val.sensors.forEach(item => {
        // item.name = item.code;
        item.sn = sn;
        this.GM606Data.push(item);
      });
    },

    // upRG04ModHandler(sn, val, beginTime, deviceType) {
    //   //   state 0 正常 1预警  2报警 3恢复
    //   let obj = {
    //     beginTime,
    //     deviceType,
    //     value: val.radDose,
    //     name: '剂量率',
    //     unitName: 'μSv/h',
    //     alarmState: val.state
    //   };

    //   if (val.state == 3) {
    //     obj.alarmState = 0;
    //   }
    //   val = { ...obj, ...val };

    //   let NRHM01Data = [];
    //   this.RG04Obj[sn] = [val];
    //   Object.keys(this.RG04Obj).forEach(key => {
    //     NRHM01Data = [...NRHM01Data, ...this.RG04Obj[key]];
    //   });
    //   this.RG04Data = NRHM01Data;
    // },

    upPMS6003ModHandler(val) {
      let newPMS6003Data = [];
      let showPmDto = ['pm25'];
      showPmDto.forEach(key => {
        let obj = {
          name: key,
          showName: Object.keys(pmNameObj).includes(key) ? pmNameObj[key] : key,
          value: val.pmDto[key],
          deviceType: val.pmDto.deviceType,
          //   alarmState: 0,
          alarmState: val.state,
          unitName: 'µg/m³'
        };
        newPMS6003Data.push(obj);
      });
      this.PMS6003Data = newPMS6003Data;
    },
    upNRHM01ModHandler(sn, val) {
      let obj = {
        deviceType: val.deviceType,
        value: val.radonConcentration,
        name: '氡气/Rn',
        unitName: 'Bq/m³',
        alarmState: val.state
      };
      val = { ...val, ...obj };

      if (val.state == 3) {
        obj.alarmState = 0;
      }

      let NRHM01Data = [];
      this.NRHM01Obj[sn] = [val];
      Object.keys(this.NRHM01Obj).forEach(key => {
        NRHM01Data = [...NRHM01Data, ...this.NRHM01Obj[key]];
      });
      this.NRHM01Data = NRHM01Data;
    },

    packageSensorViewDataHandler() {
      this.seneorList = [
        ...this.RG04Data,
        ...this.GM606Data,
        ...this.PMS6003Data,
        ...this.NRHM01Data
      ];
      //   console.log('this.seneorList: ', this.seneorList);

      this.seneorList.forEach((item, index) => {
        let { deviceType, name, value } = item;
        // console.log('name: ', name);
        // console.log('code: ', item.code);

        if (!this.seneorGrade.hasOwnProperty(deviceType)) return;
        this.seneorGrade[deviceType].forEach(sitem => {
          if (sitem.sensorTypeCode.includes(name)) {
            sitem.deviceSensorTypeGradeDtos.forEach(sensorItem => {
              if (
                value >= Number(sensorItem.gradeLowValue) &&
                value <= Number(sensorItem.gradeHighValue)
              ) {
                this.seneorList[index].color = sensorItem.gradeMark;
              }
            });
          }
        });
      });

      if (isEmpty(this.seneorList)) {
        this.empty = true;
      } else {
        this.empty = false;
      }
    },

    loadSensorGradeHandler() {
      let sensorType = ['GM606', 'RG04', 'PMS6003', 'NRH-M01'];
      getSensorsGradeServer(sensorType).then(res => {
        this.seneorGrade = res.data;
      });
    }
  },
  created() {
    this.loadSensorGradeHandler();
    this.initData();
  }
};
</script>

<style scoped lang="scss">
.wireless-box-view {
  width: 100%;
  height: 100%;

  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
